import { render, staticRenderFns } from "./receita_carbonada.vue?vue&type=template&id=698a3308&scoped=true"
import script from "./receita_carbonada.vue?vue&type=script&lang=js"
export * from "./receita_carbonada.vue?vue&type=script&lang=js"
import style0 from "./receita_carbonada.vue?vue&type=style&index=0&id=698a3308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698a3308",
  null
  
)

export default component.exports